export class ClmPerformanceOutput {

  unitFamily!: string;
  unitSize!: string;
  loadType!: string;
  blowerType!: string;
  unitRevision!: string;
  fluidFlow!: string;
  airflow!: string;
  enteringDryBulbTemperature!: string;
  enteringWetBulbTemperature!: string;
  enteringWaterTemperature!: string;
  totalCapacity!: string;
  sensibleCapacity!: string;
  leavingDryBulbTemperature!: string;
  leavingWetBulbTemperature!: string;
  pressureDrop!: string;
  leavingWaterTemperature!: string;
  heatOfExtraction!: string;
  heatOfRejection!: string;
  powerInput!: string;
  eer!: string;
  cop!: string;
  loadEnteringWaterTemperature!: string;
  loadFluidFlow!: string;
  loadLeavingWaterTemperature!: string;
  loadPressureDrop!: string;
  messages!: string[];

}
